import React, { useEffect, useMemo, useState } from 'react';
import { Modal, Button, AgGridTable, InputGroup } from 'components/common';
import { useDispatch, useSelector } from 'react-redux';
import { getAllCompetitors } from 'redux/crm/competiorSlice';
import ConfirmationModal from 'components/common/Confirmation';
import { MdDelete, MdEdit } from 'react-icons/md';
import { FaSearch } from 'react-icons/fa';
import PropTypes from 'prop-types';

const CompetiorList = ({ showModal, setshowModal }) => {
  const { data } = useSelector((state) => state.crm_competitor)
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [search, setSearch] = useState('')
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAllCompetitors())
  }, [dispatch])

  const closeModal = () => {
    setshowModal(false)
  }

  const handleClose = () => {
    closeModal()
  }

  const handleCloseConfirmation = () => {
    setShowConfirmation(false)
  }

  const handleOkConfirm = async () => {
    setShowConfirmation(false)
  }

  const handleDelete = () => {
    setShowConfirmation(true)
  }

  const handleEdit = () => {

  }

  const rows = useMemo(() => {
    if (!search) return data || [];
    const q = search.toLowerCase();
    return (data || []).filter(
      (item) => item.name?.toLowerCase().includes(q) || item.code?.toLowerCase().includes(q)
    );
  }, [data, search]);

  const columns = useMemo(() => [
    { field: 'id', headerName: 'ID#', width: 90 },
    { field: 'name', headerName: 'Name', flex: 1 },
    { field: 'code', headerName: 'Code', width: 140 },
    {
      field: 'actions',
      headerName: '',
      width: 110,
      sortable: false,
      filter: false,
      cellClass: 'tw-text-right',
      cellRenderer: (params) => {
        const { allow_edit, allow_delete } = params.data?.permissions || {};

        return (
          <span className="tw-inline-flex tw-items-center tw-gap-1">
            {allow_edit && (
              <>
                <MdEdit
                  title="Edit"
                  className="tw-mr-1 tw-cursor-pointer"
                  onClick={handleEdit}
                />
                {' | '}
              </>
            )}
            {allow_delete && (
              <MdDelete
                title="Delete"
                className="tw-cursor-pointer"
                onClick={handleDelete}
              />
            )}
          </span>
        );
      }
    }
  ], []);

  return (
    <>
      <Modal
        show={showModal}
        onHide={() => setshowModal(false)}
        title="Competitor list"
        size="xl"
        backdropClick={false}
        footer={(
          <Button size="sm" variant="ghost" onClick={handleClose}>Close</Button>
        )}
      >
        <div className="tw-flex tw-justify-end tw-items-center tw-mb-3">
          <InputGroup className="tw-w-full sm:tw-w-1/2">
            <InputGroup.Text className="tw-bg-white">
              <FaSearch className="tw-text-slate-400" />
            </InputGroup.Text>
            <input
              placeholder="Search name or code..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="tw-flex-1 tw-px-3 tw-py-2 tw-text-sm tw-border tw-border-solid tw-border-slate-300 tw-rounded-md tw-bg-white tw-text-slate-900 placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
            />
          </InputGroup>
        </div>

        <AgGridTable
          columnDefs={columns}
          rowData={rows}
          height="420px"
          pageSize={20}
          filter={false}
        />
      </Modal>

      {showConfirmation && (
        <ConfirmationModal
          show={showConfirmation}
          onHide={handleCloseConfirmation}
          onConfirm={handleOkConfirm}
          message="Are you sure to delete?"
        />
      )}
    </>
  )
};

CompetiorList.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setshowModal: PropTypes.func.isRequired
};

export default CompetiorList;
